import ExceptionIssue from '../model/ExceptionIssue'
import UnhandledException from '../model/UnhandledException'
import {
  ClearException,
  RaiseException
} from '../pages/UnhandledExceptionHandler/actions/RaiseException'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Success, Failure } from 'typescript-fsa'

export type ExceptionState = {
  errorMessage: string
  exceptionIssue?: ExceptionIssue
  unhandledException?: UnhandledException
  hasUnhandledException: boolean
}

export const exceptionInitialState = {
  errorMessage: '',
  hasUnhandledException: false
}
export const exceptionReducer = reducerWithInitialState<ExceptionState>(exceptionInitialState)
  .case(RaiseException.started, (state: ExceptionState, exception: UnhandledException) => ({
    ...state,
    errorMessage: '',
    unhandledException: exception,
    hasUnhandledException: true
  }))
  .case(
    RaiseException.done,
    (state: ExceptionState, payload: Success<UnhandledException, ExceptionIssue>) => ({
      ...state,
      exceptionIssue: payload.result
    })
  )
  .case(
    RaiseException.failed,
    (state: ExceptionState, error: Failure<UnhandledException, { message: string }>) => ({
      ...state,
      errorMessage: error.error.message
    })
  )
  .case(ClearException, (state: ExceptionState) => ({
    ...state,
    errorMessage: '',
    exceptionIssue: undefined,
    unhandledException: undefined,
    hasUnhandledException: false
  }))
